module.exports = __webpack_public_path__ + "static/media/whatsapp.48845275.webp";